import { AngularFireDatabaseModule } from '@angular/fire/database';

///////////////////////////////////////////////////////
// Angular
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
///////////////////////////////////////////////////////
// Locales
import { registerLocaleData, DatePipe } from '@angular/common';
import localeESMX from '@angular/common/locales/es-MX';
registerLocaleData(localeESMX, 'es-MX');

///////////////////////////////////////////////////////
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
///////////////////////////////////////////////////////

///////////////////////////////////////////////////////
// Material
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule, MatPaginatorModule } from '@angular/material';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatInputModule } from '@angular/material/input';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatDividerModule } from '@angular/material/divider';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatProgressSpinnerModule, MatSpinner } from '@angular/material/progress-spinner';
import { OverlayModule } from '@angular/cdk/overlay';
import { CustomFormsModule } from 'ng2-validation';
import { MatSortModule } from '@angular/material';
///////////////////////////////////////////////////////

///////////////////////////////////////////////////////
// Azure
import { MsalModule, MsalInterceptor } from '@azure/msal-angular';
import { SsoAuthService } from './services/sso-auth.service';

///////////////////////////////////////////////////////

///////////////////////////////////////////////////////
// Unauthenticated
import { ResetPasswordComponent } from './unauthenticated/reset-password/reset-password.component';
import { RegisterComponent } from './unauthenticated/register/register.component';
import { PageNotFoundComponent } from './unauthenticated/page-not-found/page-not-found.component';
///////////////////////////////////////////////////////

///////////////////////////////////////////////////////
// dialogs
import { UiService } from './services/ui.service';
import { InfoDialogComponent } from './dialogs/info-dialog/info-dialog.component';
import { CancelConfirmDialogComponent } from './dialogs/cancel-confirm-dialog/cancel-confirm-dialog.component';
import { RejectDialogComponent } from './dialogs/reject-dialog/reject-dialog.component';
import { SsoauthComponent } from './authenticated/pages/ssoauth/ssoauth.component';
import { environment } from '../environments/environment';
import { LoginComponent } from './unauthenticated/login/login.component';
import { SsoLoginComponent } from './unauthenticated/sso-login/sso-login.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ChangePasswordComponent } from './dialogs/change-password/change-password.component';
///////////////////////////////////////////////////////

///////////////////////////////////////////////////////
// akiba services
import { AuthenticationService } from './services/authentication.service';
import { DataSourceService } from './services/data-source.service';
///////////////////////////////////////////////////////

////////////////////////////////////////////////////////
// Firebase
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule, FirestoreSettingsToken } from '@angular/fire/firestore';
import { AngularFireStorageModule, StorageBucket } from '@angular/fire/storage';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireFunctionsModule } from '@angular/fire/functions';
import { AuthenticatedModule } from './authenticated/authenticated.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { InvestmentReturnDialogComponent } from './investment-return-dialog/investment-return-dialog.component';
///////////////////////////////////////////////////////


///////////////////////////////////////////////////////

@NgModule({
  declarations: [
    AppComponent,
    ResetPasswordComponent,
    RegisterComponent,
    PageNotFoundComponent,
    InfoDialogComponent,
    ChangePasswordComponent,
    RejectDialogComponent,
    CancelConfirmDialogComponent,
    SsoauthComponent,
    LoginComponent,
    SsoLoginComponent,
    InvestmentReturnDialogComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    AngularFireAuthModule,
    AngularFireStorageModule,
    AngularFireFunctionsModule,
    AngularFireDatabaseModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatSnackBarModule,
    MatMomentDateModule,
    MatDividerModule,
    MatDialogModule,
    MatDatepickerModule,
    MatSortModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    OverlayModule,
    CustomFormsModule,
    MsalModule.forRoot({
      clientID: environment.OAuthSettings.appId,
      consentScopes: environment.OAuthSettings.scopes,
      authority: environment.OAuthSettings.authority,
      redirectUri: environment.OAuthSettings.redirectUri,
      navigateToLoginRequestUrl: environment.OAuthSettings.navigateToLoginRequestUrl,
      popUp: environment.OAuthSettings.popUp,
      // cacheLocation: environment.OAuthSettings.cacheLocation,
      protectedResourceMap: environment.OAuthSettings.protectedResourceMap as [string, string[]][]
    }),
    AuthenticatedModule,
    AppRoutingModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: false })
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'es-MX' },
    UiService,
    DatePipe,
    DataSourceService,
    AuthenticationService,
    MomentDateAdapter,
    SsoAuthService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    { provide: StorageBucket, useValue: environment.firebase.storageBucket },
    { provide: FirestoreSettingsToken, useValue: {} },
  ],
  entryComponents: [
    CancelConfirmDialogComponent,
    InfoDialogComponent,
    MatSpinner,
    RejectDialogComponent,
    ChangePasswordComponent,
    InvestmentReturnDialogComponent
  ],
  exports: [
    MatSortModule,
    MatPaginatorModule
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
